import { Directive } from '@angular/core';

@Directive({
  selector: '[mbsInputAppend]'
})
export class InputAppendDirective {}
